'use client';

import { type JSX, useActionState } from 'react';
import bookDemo, { type BookDemoState } from '@/actions/bookDemo';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import LoadingIcon from '@/icons/LoadingIcon';

const initialState: BookDemoState = { status: 'idle' };

const BookDemoForm = ({
  Trigger = (
    <Button
      size='lg'
      type='submit'
    >
      Boka demo
    </Button>
  ),
}: {
  Trigger?: JSX.Element;
}) => {
  const [state, formAction, isPending] = useActionState(bookDemo, initialState);
  const display = isPending ? 'pending' : state.status;

  return (
    <Dialog>
      <DialogTrigger asChild>{Trigger}</DialogTrigger>
      <DialogContent className='z-9999'>
        <DialogHeader>
          <DialogTitle>Boka demo</DialogTitle>
          {display === 'idle' && (
            <DialogDescription>Fyll i formuläret så kontaktar vi dig inom kort.</DialogDescription>
          )}
          {display === 'success' && <p>Tack, vi hör av oss!</p>}
          {display === 'pending' && (
            <div className='self-center'>
              <LoadingIcon />
            </div>
          )}
          {display === 'error' && (
            <p>
              Hoppsan, något gick fel. Du kan istället nå oss på{' '}
              <a
                href='mailto:pro@booli.se'
                className='text-bui-color-blue underline'
              >
                pro@booli.se
              </a>
            </p>
          )}
          {display === 'idle' && (
            <form
              className='grid grid-cols-1 gap-2 pt-4'
              action={formAction}
            >
              <div className='flex gap-4'>
                <div className='w-1/2'>
                  <Label htmlFor='first'>Förnamn</Label>
                  <Input
                    type='text'
                    name='first'
                    className='border-bui-color-silver'
                    required
                  />
                </div>
                <div className='w-1/2'>
                  <Label htmlFor='last'>Efternamn</Label>
                  <Input
                    type='text'
                    name='last'
                    className='border-bui-color-silver'
                    required
                  />
                </div>
              </div>
              <div className='flex flex-col gap-2'>
                <div>
                  <Label htmlFor='email'>Email</Label>
                  <Input
                    type='email'
                    name='email'
                    className='border-bui-color-silver'
                    required
                  />
                </div>
                <div>
                  <Label htmlFor='phone'>Telefonnummer</Label>
                  <Input
                    type='tel'
                    name='phone'
                    className='border-bui-color-silver'
                    required
                  />
                </div>
                <div>
                  <Label htmlFor='company'>Företag</Label>
                  <Input
                    type='text'
                    name='company'
                    placeholder='Ange företagsnamn'
                    className='border-bui-color-silver'
                    required
                  />
                </div>
                <div>
                  <Label htmlFor='message'>Meddelande</Label>
                  <Textarea
                    name='message'
                    placeholder='Kort beskrivning'
                    className='border-bui-color-silver mt-3'
                    maxLength={1000}
                    required
                  />
                </div>
                <Button
                  size='lg'
                  type='submit'
                  className='mt-2'
                >
                  Boka demo
                </Button>
              </div>
            </form>
          )}
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default BookDemoForm;
